import { FetchProxy } from "intraactive-sdk-helper";
import { sdkContainerInstance } from "../global/Container";
import { ITheme } from "../interfaces/ITheme";
import { Environment } from "./Environment";

export default class ThemeService {

  public static getThemes(environment: "Development" | "Test" | "Production", token: string, tenant: string): Promise<ITheme[]> {
    return new Promise((resolve) => {
      if (environment && tenant && token) {
      const apiUrl = `${Environment.getEnvironmentForThemeAPI(environment)}/api/${tenant}`;
      new FetchProxy(apiUrl, { method: "GET", headers: { 'Content-Type': 'application/json', 'AuthToken': token } })
        .withContainer(sdkContainerInstance)
        .fetch()
        .then((response) => {
          if (!response.ok) {
            return response.status;
          } else {
            return response.json();
          }
        }).then(response => {
          resolve(response);
        }).catch(error => {
          console.log(error);
        });
      } else {
        resolve(null);
      }
    });
  }

  public static updateTheme(environment: "Development" | "Test" | "Production", token: string, tenant: string, theme: ITheme): Promise<string> {
    return new Promise<string>((resolve: (status: string) => void, reject: (error: any) => void): void => {
      if (environment && tenant && token && theme) {
        const apiUrl = `${Environment.getEnvironmentForThemeAPI(environment)}/api/${tenant}/${theme.Name}`;
        const body: string = JSON.stringify(theme);
        new FetchProxy(apiUrl, { method: "PUT", headers: { 'Content-Type': 'application/json', 'AuthToken': token }, body: body })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              reject(response);
              return;
            }
            return resolve(response.statusText);
          })
          .catch(error => {
            console.log(error);
            reject(null);
          });
      } else {
        reject(null);
      }
    });
  }

  public static deleteTheme(environment: "Development" | "Test" | "Production", token: string, tenant: string, id: string): Promise<string> {
    return new Promise<string>((resolve: (status: string) => void, reject: (error: any) => void): void => {
      if (environment && tenant && token && id) {
        const apiUrl = `${Environment.getEnvironmentForThemeAPI(environment)}/api/${tenant}/${id}`;
        new FetchProxy(apiUrl, { method: "DELETE", headers: { 'Content-Type': 'application/json', 'AuthToken': token } })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              reject(response);
              return;
            }
            return resolve(response.statusText);
          })
          .catch(error => {
            console.log(error);
            reject(null);
          });
      } else {
        reject(null);
      }
    });
  }

  public static getCdnStatus(environment: "Development" | "Test" | "Production", token: string, tenant: string): Promise<ICdnStatus> {
    return new Promise((resolve) => {
      if (environment && tenant && token) {
      const apiUrl = `${Environment.getEnvironmentForThemeAPI(environment)}/api/${tenant}/cdnstatus`;
      new FetchProxy(apiUrl, { method: "GET", headers: { 'Content-Type': 'application/json', 'AuthToken': token } })
        .withContainer(sdkContainerInstance)
        .fetch()
        .then((response) => {
          if (!response.ok) {
            return response.status;
          } else {
            return response.json();
          }
        }).then(response => {
          resolve(response);
        }).catch(error => {
          console.log(error);
        });
      } else {
        resolve(null);
      }
    });
  }

}

interface ICdnStatus{
  private: ICdnValue;
  public: ICdnValue;
}

interface ICdnValue{
  Value: boolean;
}